export type SnackKey = string | number;

export const MAX_CONCURRENT_SNACKS = 2;

export const snackDedupeKey = (message: unknown, variant: string): SnackKey | null =>
	typeof message === "string" && message.length > 0 ? `${variant}:${message}` : null;

let active: SnackKey[] = [];

const admit = (key: SnackKey): SnackKey[] => {
	if (active.includes(key)) return [];
	active = [...active, key];
	if (active.length <= MAX_CONCURRENT_SNACKS) return [];
	const evicted = active.slice(0, active.length - MAX_CONCURRENT_SNACKS);
	active = active.slice(evicted.length);
	return evicted;
};

const release = (key: SnackKey): void => {
	active = active.filter((candidate) => candidate !== key);
};

const activeKeys = (): SnackKey[] => [...active];

const reset = (): void => {
	active = [];
};

const snackStack = { activeKeys, admit, release, reset };

export default snackStack;
